import { useRef, useState } from 'react';

export const useStateWithRef = (initialValue) => {
  const [item, setItem] = useState(initialValue);
  const itemRef = useRef();
  itemRef.current = item;

  return [item, setItem, itemRef];
};
